
export class Searchpost {
    slug : string;

}
